import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { PromotionsService } from 'app/services/promotions.service';
import { ToasterService } from 'angular2-toaster';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'promotions',
  styleUrls: ['./promotions.component.scss'],
  templateUrl: './promotions.component.html',
})
export class PromotionsComponent implements OnInit {
  promotions;

  @Input() location: 'gallery' | 'design-request' | 'checkout';
  @Output() promocodeActivated = new EventEmitter();

  constructor(
    private promotionsService: PromotionsService,
    private toasterService: ToasterService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    // this.promotionsService.load(this.location).subscribe((promotions) => {
    //   this.promotions = promotions;
    // });
  }

  activate(code) {
    this.translate
      .get('code_added', { code })
      .subscribe(message => {
        this.toasterService.pop('success', undefined, message);
      });
    this.promocodeActivated.emit(code);
    this.promotionsService.activate(code);
  }
}
